@let info = infoSg();

<atn-summit-pulse-section
  class="atn-summit-pulse-highlights"
  [name]="info.name"
  [subtitle]="info.description"
>
  @for (highlight of info.highlights; track $index) {
    <div class="atn-summit-pulse-highlights__highlight">
      <h4 class="atn-summit-pulse-highlights__highlight-title">
        {{ highlight.name }}
      </h4>
      <p class="atn-summit-pulse-highlights__highlight-description">
        {{ highlight.description }}
      </p>
    </div>
  }
</atn-summit-pulse-section>
